<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_BASE_YEAR'
        )
      }"
    >
      <select
        v-model="$parent.project.UF_BASE_YEAR"
        class="sel-dropdown i-main-style i-wid-13"
      >
        <option
          v-for="year in baseYearList"
          v-bind:value="year"
          v-bind:key="year"
          v-text="year"
        ></option>
      </select>
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_BASE_YEAR")
        }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_base_year",
  data() {
    return {
      baseYearList: []
    };
  },
  async created() {
    let currentDate = new Date().getFullYear();
    for (let i = 2018; i <= currentDate + 5; i++) {
      this.baseYearList.push(i);
    }
  },
  methods: {}
};
</script>

<style scoped></style>
